import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { Menu, notification, Pagination, Spin } from "antd";
import { ROLE } from "constants/phase";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useOutletContext, useParams } from "react-router-dom";
import { convertIsoDateToStandardFormat } from "utils/date";

import DeleteModal from "../../../components/common/Modals/component";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
// import VideoGroup from "../../../components/icons/VideoGroup";
import amplitude from "../../../externals/amplitude";
import { addCategoryValidation } from "../../../utils/validations";

const AddContentCategory = (props) => {
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const {
    loder,
    settingsRecordsPerPage,
    getAllCategory,
    getCreateCategory,
    deleteCategory,
    selectedCategories,
    userRole,
    ENTITY_TYPE,
  } = props;
  const { entityId } = useOutletContext();

  const { id } = useParams();
  const [delmodalOpen, setDeleteModalOpen] = useState(false);
  const [deleteEvents, setDeleteEvents] = useState(false);
  const [loderCategory, setLoderCategory] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(20);
  const [allCategory, setCategory] = useState([]);
  const copyToClipBoardFun = (command) => {
    navigator.clipboard.writeText(command);
  };

  const tableAction = (event) => (
    <Menu
      items={[
        {
          label: (
            <a
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                delOpen(event);
              }}
            >
              <DeleteIcon />
              <span>Delete</span>
              {loder == false ? (
                ""
              ) : (
                <Spin
                  size="large"
                  indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                  className="loader__full"
                ></Spin>
              )}
            </a>
          ),
          key: "1",
        },
      ]}
    />
  );

  const handlePageChange = (current) => {
    setActivePage(current);
    setEnd(current * settingsRecordsPerPage);
    setStart(current * settingsRecordsPerPage - settingsRecordsPerPage);
    amplitude.logEvent("category_pagination", { page: current });
  };

  const delOpen = (streamId) => {
    setDeleteEvents(streamId);
    setDeleteModalOpen(true);
  };
  const deleteCategoryModel = async () => {
    setLoderCategory(true);
    const event = deleteEvents;
    const { value } = await deleteCategory({
      id: event,
    });
    if (value.success) {
      setLoderCategory(false);
      getAllCategorys();
      delclose();
      notification["success"]({ message: value.message });
    } else {
      delclose();
      notification["error"]({ message: value.message });
    }
    amplitude.logEvent("category_deleted", { category: event });
  };
  const openModal = () => {
    setIsOpen(true);
    amplitude.logEvent("add_category_clicked");
  };
  const delclose = () => {
    setDeleteModalOpen(false);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const [initialState] = useState({
    catName: "",
  });
  const handleSubmit = async ({ catName }) => {
    const { value } = await getCreateCategory({
      name: catName,
      contentType: "sport",
    });
    if (value.success) {
      notification["success"]({ message: value.message });
    }
    closeModal();
    getAllCategorys();
    // }
  };

  const setCategoryData = () => {
    const data = selectedCategories.map((e) => {
      return { name: e };
    });
    setCategory(data || []);
  };

  const getAllCategorys = async () => {
    if (id) {
      const { value } = await getAllCategory({
        entityId: id,
      });
      if (value?.success) {
        setCategory(value.data);
      }
    }
  };

  useEffect(() => {
    if (userRole === ROLE.SUPER_ADMIN) {
      setCategoryData();
    } else {
      getAllCategorys();
    }
  }, [id]);

  return (
    <>
      <DeleteModal
        modalIsOpen={delmodalOpen}
        setDeleteModalOpen={setDeleteModalOpen}
        deleteComanModel={deleteCategoryModel}
        loder={loderCategory}
        header="Delete"
        content="Are you sure you want to delete?"
      />

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Add content Category</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik initialValues={initialState} validationSchema={addCategoryValidation} onSubmit={handleSubmit}>
            {({ errors, touched }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="field-items mb-4">
                      <label className="form-label">
                        Category Name <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="catName" type="text" />
                      {touched.catName && errors.catName && <div className="invalid-feedback">{errors.catName}</div>}
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button className="btn btn-primary" type="submit">
                        Add
                        {loder && (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
      <div className="col-md-12">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Category</h4>
            <p>Entertainment, Sports, News</p>
          </div>
          {/* <div className="right-btn-block">
            <div class="button-container"> */}
          {/* <button class="btn-s-one me-3">
                <UploadIconBlue className="me-2" /> Upload a CSV file{" "}
              </button> */}
          {/* {userData?.role === "superadmin" ? ( */}
          {/* <AccessControl code="add_category" page="configuration">
                <button class="btn btn-primary" onClick={openModal}>
                  Add Category
                </button>
              </AccessControl> */}
          {/* ) : null} */}
          {/* </div>
          </div> */}
        </div>
        <div className="configuration-items-row mt-5 row">
          <div className="col-md-12">
            <h5 className="title-small">Added Category</h5>
          </div>
          {allCategory?.slice(start, end)?.map((data) => {
            return (
              <>
                <div className="col-md-2">
                  <div className="confi-block-col-container configuration-column flex-column gap-0 p-2">
                    {/* {userData?.role === "superadmin" ? ( */}
                    {/* <AccessControl code="delete_category" page="configuration">
                      <Dropdown
                        className=""
                        overlay={tableAction(data?._id)}
                        trigger={["click"]}
                        overlayClassName={"tableActionBlock"}
                        placement={"bottomRight"}
                      >
                        <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                          <TdiVerticalDark />
                        </a>
                      </Dropdown>
                    </AccessControl> */}
                    {/* ) : null} */}
                    {/* <div className="vv-video-action-bar">
                      <a
                        className="ant-dropdown-link"
                        onClick={() => {
                          copyToClipBoardFun(data?.value);
                        }}
                      >
                        <Tooltip title={`Click to copy value: ${data.displayName}`}>
                          <InfoCircleOutlined style={{ fontSize: "18px", color: "#000" }} />
                        </Tooltip>
                      </a>
                    </div> */}
                    {/* <div className="icon-block">
                      <VideoGroup />
                    </div> */}
                    <div className="confi-block-col">
                      <h4 className="word-break-common">
                        {data.displayName &&
                          data.displayName
                            .split(" ")
                            .map((letter, index) => letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase())
                            .join(" ")}
                      </h4>
                      <h6> {data?.createdAt ? convertIsoDateToStandardFormat(data?.createdAt) : ""}</h6>
                    </div>

                    {/* <div className="action-buttons">
                      <AccessControl code="delete_category" page="configuration">
                        <button>
                          <Delete
                            onClick={() => {
                              delOpen(data);
                            }}
                          />
                        </button>
                      </AccessControl>
                    </div> */}
                    {/* <div className="btn-action">
                        <button className="btn btn-edit btn-primary">Edit</button>
                      </div>  */}
                  </div>
                </div>
              </>
            );
          })}
        </div>
        <Pagination
          showSizeChanger={false}
          current={activePage}
          onChange={handlePageChange}
          pageSize={settingsRecordsPerPage}
          total={allCategory?.length}
          className="text-center mt-3"
        />
      </div>
    </>
  );
};

export default AddContentCategory;
